export default {
	legacySyncBanner: {
		title: 'Important sync update available',
		message:
			'An important update for your data synchronisation is available. The previous automatic update channel is no longer available. Please install the update once using the installer.',
		download: 'Download installer',
		dismiss: 'Dismiss notice',
		downloadError:
			'The installer link could not be retrieved right now. Please try again shortly.',
	},
}
